var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score-header"},[_c('h2',[_c('img',{staticClass:"score-coin",attrs:{"src":"/img/csoin21.png"}}),_vm._v(" امتیاز شما : "),_c('span',[_vm._v(_vm._s(_vm.getScore)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }